import { Bar, PolarArea } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    RadialLinearScale,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTasks, updateTaskStatus } from "../../slices/company/taskSlice";
import moment from "moment";
import { ArrowRightFromLine } from "lucide-react";
import { API_URL } from "../../utils/constant";
import { getModulePermissions } from '../../utils/getPermissions';
import { fetchSuppliers } from '../../slices/company/supplierSlice';
import { fetchBrands } from '../../slices/company/brandSlice';

ChartJS.register(CategoryScale, LinearScale, RadialLinearScale, BarElement, ArcElement, Title, Tooltip, Legend, ChartDataLabels);
const CompanyDashboard = () => {
    const monthLabels = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const FILTERS = [
        { value: "month", label: "Month Wise" },
        { value: "day", label: "Day Wise (This Week)" },
        { value: "quarter", label: "Quarter Wise" },
        { value: "year", label: "Year Wise" },
        { value: "custom", label: "Custom Range" },
    ];


    const FILTERCHANGED = [
        { value: "day", label: "Today" },
        { value: "month", label: "This Month" },
        { value: "quarter", label: "This Quarter" },
        { value: "year", label: "This Year" },
        { value: "custom", label: "Custom Range" },
    ];

    const paymentModeLabels = [
        "Cash",
        "Gpay UPI",
        "Phonepe upi",
        "Paytm upi",
        "Bharat pay upi",
        "Debit card",
        "Credit card",
        "Bhim upi",
        "Amazon pay upi",
        'Axis Bank Pos',
        'Phonepe - UCO Bank Pos',
        'Card',
        'UPI',
        'Partial Payment'
    ];

    const paymentModeColors = [
        "#5a66f1", "#60a5fa", "#cbd5e1", "#f59e42", "#34d399",
        "#f43f5e", "#a78bfa", "#fbbf24", "#10b981"
    ];
    const [dashboardData, setDashboardData] = useState(null);
    const companyID = localStorage.getItem('companyID');

    const [filter, setFilter] = useState("month");
    const [filterSales, setFilterSales] = useState("day");
    const [customStart, setCustomStart] = useState("");
    const [customEnd, setCustomEnd] = useState("");
    const [filter_payment, setFilter_payment] = useState("day");
    const [customStartPayment, setCustomStartPayment] = useState("");
    const [customEndPayment, setCustomEndPayment] = useState("");

    const [filter_payment_date, setFilter_payment_date] = useState("day");
    const [customStartPaymentDate, setCustomStartPaymentDate] = useState("");
    const [customEndPaymentDate, setCustomEndPaymentDate] = useState("");

    const [filter_segment, setFilter_segment] = useState("day");
    const [customStartSegment, setCustomStartSegment] = useState("");
    const [customEndSegment, setCustomEndSegment] = useState("");

    const [salesData, setSalesData] = useState([]);
    const [labels, setLabels] = useState(monthLabels);

    const [segmentSales, setSegmentSales] = useState([]);
    const [segmentLabels, setSegmentLabels] = useState([]);
    const [segmentColors, setSegmentColors] = useState([
        "#5a66f1", "#60a5fa", "#cbd5e1", "#f59e42", "#34d399",
        "#f43f5e", "#a78bfa", "#fbbf24", "#10b981", "#f87171"
    ]);


    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };



    const getMonthStart = () => {
        const now = new Date();
        return formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
    };

    const getToday = () => formatDate(new Date());

    const [filterStartDate, setFilterStartDate] = React.useState(getMonthStart());
    const [filterEndDate, setFilterEndDate] = React.useState(getToday());
    const [filterVendor, setFilterVendor] = React.useState("");
    const [filterBrand, setFilterBrand] = React.useState("");
    const [filterSegment, setFilterSegment] = React.useState("");
    const [filterSubSegment, setFilterSubSegment] = React.useState("");

    // Options for dropdowns
    const { suppliers = [], } = useSelector((state) => state.suppliers);
    const { brands } = useSelector((state) => state.brands);
    const [segments, setSegments] = React.useState([]);
    const [subSegments, setSubSegments] = React.useState([]);
    const dispatch = useDispatch();

    const [segmentsData, setSegmentsData] = useState([]);
    const [subSegmentsData, setSubSegmentsData] = useState([]);

    useEffect(() => {
        async function fetchSegementAndSubSegment() {
            try {
                const res = await fetch(`${API_URL}/companies/dashboard/segment-and-subsegment/${companyID}`);
                const data = await res.json();
                setSegmentsData(data.segments || []);
                setSubSegmentsData(data.subSegments || []);
                console.log("Segments & Sub-segments:", data);
            } catch (err) {
                console.error('Error fetching segments & sub-segments:', err);
            }
        }
        if (companyID) fetchSegementAndSubSegment();
    }, [companyID]);


    useEffect(() => {
        // async function fetchDashboardData() {
        //     try {
        //         const res = await fetch(`${API_URL}/companies/dashboard/data/${companyID}`);
        //         const data = await res.json();
        //         setDashboardData(data);
        //     } catch (err) {
        //         console.error('Error fetching dashboard data:', err);
        //     }
        // }
        // if (companyID) fetchDashboardData();
        fetchDashboardData();
    }, [companyID]);


    useEffect(() => {
        async function fetchSales(filter, customStart, customEnd) {
            // console.log(filter);
            let url = `${API_URL}/companies/dashboard/sales/data/${companyID}?filter=${filter}`;
            if (filter === "custom" && customStart && customEnd) {
                url += `&start=${customStart}&end=${customEnd}`;
            }

            try {
                const res = await fetch(url);
                const result = await res.json();

                // Expecting: [{ label: "Jan", value: 1200 }, { label: "Feb", value: 800 }]
                const lbls = result.map(item => item.label);
                const data = result.map(item => Number(item.value));

                setLabels(lbls);
                setSalesData(data);
            } catch (err) {
                console.error("Error fetching sales:", err);
                setLabels([]);
                setSalesData([]);
            }
        }
        fetchSales(filter, customStart, customEnd);
    }, [filter, customStart, customEnd, companyID]);


    const chartData = {
        labels,
        datasets: [
            {
                label: "Sales",
                data: salesData,
                backgroundColor: "#d32f2f",
                // barThickness: 90,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: false },
            datalabels: {
                anchor: 'center',
                align: 'center',
                color: '#fff',
                font: { weight: 'bold', size: 12 },
                formatter: function (value) {
                    return value.toFixed ? value.toFixed(2) : value;
                },
                display: false
            }
        },
        // scales: {
        //     y: { beginAtZero: true },
        // },
        scales: {
            x: {
                grid: {
                    display: false, // ❌ no vertical grid
                    drawBorder: false,
                },
                ticks: {
                    color: "#6b7280",
                    font: { size: 12 },
                },
            },

            y: {
                beginAtZero: true,
                grid: {
                    drawBorder: false,
                    color: "#e5e7eb",          // light gray background
                    borderDash: [6, 6],        // dashed like image
                },
                ticks: {
                    color: "#6b7280",
                    callback: value => `${value / 1000}K`,
                },
            },
        },

        elements: {
            bar: {
                borderRadius: 10,              // ✅ rounded bars
                borderSkipped: false,          // round top & bottom
            },
        },
    };


    const [paymentModeSales, setPaymentModeSales] = useState([]);

    // Fetch payment mode sales based on filter
    useEffect(() => {
        async function fetchPaymentModeSales() {
            let url;
            if (filter_payment != "custom") {
                url = `${API_URL}/companies/dashboard/payment/${companyID}?filter=${filter_payment}`;
            }
            if (filter_payment === "custom" && customStartPayment && customEndPayment) {
                url = `${API_URL}/companies/dashboard/payment/${companyID}?filter=${filter_payment}&start=${customStartPayment}&end=${customEndPayment}`;
            }
            // Replace below with your actual API call
            try {
                const res = await fetch(url);
                const data = await res.json();
                setPaymentModeSales(data.paymentModeSales || []);
            } catch (err) {
                // fallback to dashboardData if API fails
                setPaymentModeSales(dashboardData?.paymentModeSales || []);
            }
        }
        if (companyID) fetchPaymentModeSales();
    }, [companyID, filter_payment, customStartPayment, customEndPayment, dashboardData]);

    const paymentModeChartData = {
        labels: paymentModeLabels,
        datasets: [
            {
                label: "Sales by Payment Mode",
                data: paymentModeLabels.map(
                    mode => paymentModeSales.find(m => m.mode === mode)?.total || 0
                ),
                backgroundColor: paymentModeColors,
            },
        ],
    };

    const paymentModeChartOptions = {
        indexAxis: 'y',
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: false },
            datalabels: {
                anchor: 'end', // Show label at end of bar
                align: 'end',
                color: '#222', // Dark color for contrast
                font: { weight: 'bold', size: 10 },
                formatter: function (value) {
                    // Always show value, even if small
                    return value > 0 ? (value.toFixed ? value.toFixed(2) : value) : '';
                },
                display: false,
                clamp: true, // Prevent label from being hidden
                clip: false, // Allow label outside chart area
            }
        },
        scales: {
            x: { beginAtZero: true },
            y: { ticks: { font: { size: 10 } } },
        },
        elements: {
            bar: {
                borderRadius: 5,              // ✅ rounded bars
                borderSkipped: false,          // round top & bottom
            },
        },
    };


    useEffect(() => {
        async function fetchSegmentSales() {
            let url = `${API_URL}/companies/dashboard/segement/${companyID}?filter=${filter_segment}`;
            if (filter_segment === "custom" && customStartSegment && customEndSegment) {
                url += `&start=${customStartSegment}&end=${customEndSegment}`;
            }
            try {
                const res = await fetch(url);
                const data = await res.json();
                setSegmentSales(data.segmentVariantSales || []);
                setSegmentLabels(data.segmentVariantSales ? data.segmentVariantSales.map(s => s.segment) : []);
            } catch (err) {
                setSegmentSales([]);
                setSegmentLabels([]);
            }
        }
        if (companyID) fetchSegmentSales();
    }, [companyID, filter_segment, customStartSegment, customEndSegment]);

    const segmentChartData = {
        labels: segmentLabels,
        datasets: [
            {
                label: "Sales % by Product type",
                data: segmentSales.map(s => s.count),
                backgroundColor: segmentColors.slice(0, segmentSales.length),
            },
        ],
    };

    const segmentChartOptions = {
        responsive: true,
        plugins: {
            legend: { position: 'bottom' },
            title: { display: false },

        },
    };



    const [paymentModeDateSales, setPaymentModeDateSales] = useState([]);
    const [paymentModeDateLabels, setPaymentModeDateLabels] = useState([]);
    const [selectedPaymentModes, setSelectedPaymentModes] = useState(paymentModeLabels);

    useEffect(() => {
        async function fetchPaymentModeDateSales() {
            let url = `${API_URL}/companies/dashboard/payment/date/${companyID}?filter=${filter_payment_date}`;
            if (filter_payment_date === "custom" && customStartPaymentDate && customEndPaymentDate) {
                url += `&start=${customStartPaymentDate}&end=${customEndPaymentDate}`;
            }
            try {
                const res = await fetch(url);
                const data = await res.json();
                // Example data: [{ date: "2025-09-04", Cash: 412.11, ... }]
                const rows = data.chartData || [];
                const dates = rows.map(row => row.date);

                // Build datasets for each payment mode
                const datasets = paymentModeLabels.map((mode, idx) => ({
                    label: mode,
                    data: rows.map(row => row[mode] ?? 0),
                    backgroundColor: paymentModeColors[idx % paymentModeColors.length],
                }));

                setPaymentModeDateLabels(dates);
                setPaymentModeDateSales(datasets);
            } catch (err) {
                setPaymentModeDateSales([]);
                setPaymentModeDateLabels([]);
            }
        }
        if (companyID) fetchPaymentModeDateSales();
    }, [companyID, filter_payment_date, customStartPaymentDate, customEndPaymentDate]);

    const paymentModeDateChartData = {
        labels: paymentModeDateLabels, // array of dates
        datasets: paymentModeDateSales.filter(ds => selectedPaymentModes.includes(ds.label)), // one dataset per payment mode
    };

    const paymentModeDateChartOptions = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
            title: { display: false, text: 'Payment Mode Wise Sales (Date Wise)' },
            datalabels: {
                anchor: 'center',
                align: 'center',
                color: '#fff',
                font: { weight: 'bold', size: 12 },
                formatter: function (value) {
                    return value > 0 ? (value.toFixed ? value.toFixed(2) : value) : '';
                },
                display: false
            }
        },
        scales: {
            x: { stacked: true, ticks: { font: { size: 8 } } },
            y: { stacked: true, beginAtZero: true },
        },
    };

    // UI for selecting payment modes (optional)
    const renderPaymentModeSelector = () => (
        <div className="mb-2">
            <label className="me-2">Show Payment Modes:</label>
            {paymentModeLabels.map(mode => (
                <label key={mode} className="me-2">
                    <input
                        type="checkbox"
                        checked={selectedPaymentModes.includes(mode)}
                        onChange={e => {
                            setSelectedPaymentModes(prev =>
                                e.target.checked
                                    ? [...prev, mode]
                                    : prev.filter(m => m !== mode)
                            );
                        }}
                    /> {mode}
                </label>
            ))}
        </div>
    );

    const formatAmount = (val) => {
        const num = Number(val);
        return isNaN(num) ? '0.00' : num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    console.log("Dashboard Data:", dashboardData);

    // State for filters

    // Fetch options on mount
    React.useEffect(() => {
        // Vendors
        dispatch(fetchSuppliers(companyID));
        // Brands
        dispatch(fetchBrands(companyID));
    }, []);

    const resetDashboardFilters = () => {
        setFilterStartDate("");
        setFilterEndDate("");
        setFilterVendor("");
        setFilterBrand("");
        setFilterSegment("");
        setFilterSubSegment("");
        fetchDashboardData({ startDate: "", endDate: "", vendorID: "", brandID: "", segment: "", subSegment: "" });
    };
    // Filter UI
    const renderDashboardFilters = () => (
        <div className='card'>
            <div className="card-body">
                <div className="row mb-3">
                    <div className="col-md-2">
                        <div className="position-relative">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                Vendors
                            </span>
                            <select className="form-select" value={filterVendor} onChange={e => setFilterVendor(e.target.value)}>
                                <option value="">All</option>
                                {suppliers.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
                            </select>
                        </div>
                    </div>
                    {/* <div className="col-md-3">
                        <label>Brand</label>
                        <select className="form-select" value={filterBrand} onChange={e => setFilterBrand(e.target.value)}>
                            <option value="">All</option>
                            {brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                        </select>
                    </div> */}
                    <div className="col-md-2">
                        <div className="position-relative">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                Segment
                            </span>
                            <select className="form-select" value={filterSegment} onChange={e => setFilterSegment(e.target.value)}>
                                <option value="">All</option>
                                {segmentsData.map(s => <option key={s} value={s}>{s}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="position-relative">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                Sub-Segment
                            </span>
                            <select className="form-select" value={filterSubSegment} onChange={e => setFilterSubSegment(e.target.value)}>
                                <option value="">All</option>
                                {subSegmentsData.map(ss => <option key={ss} value={ss}>{ss}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-3">

                        <div className='input-group'>
                            <div className="position-relative">
                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2" style={{ zIndex: "1" }}>
                                    Start Date
                                </span>
                                <input type="date" className="form-control" value={filterStartDate} onChange={e => setFilterStartDate(e.target.value)} />
                            </div>
                            <div className="position-relative">
                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2" style={{ zIndex: "1" }}>
                                    End Date
                                </span>
                                <input type="date" className="form-control" value={filterEndDate} onChange={e => setFilterEndDate(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 d-flex align-items-end gap-2">
                        <button className="btn btn-primary w-100" onClick={() => fetchDashboardData()}> <i className='fas fa-check'></i> Apply</button>
                        <button className="btn btn-secondary w-100" onClick={() => resetDashboardFilters()}> <i className='fas fa-remove'></i> Reset</button>
                    </div>
                </div>
            </div>
        </div>
    );

    // Fetch dashboard data with filters
    const fetchDashboardData = (overrideParams) => {
        const params = new URLSearchParams();
        const start = overrideParams && overrideParams.startDate !== undefined ? overrideParams.startDate : filterStartDate;
        const end = overrideParams && overrideParams.endDate !== undefined ? overrideParams.endDate : filterEndDate;
        const vendor = overrideParams && overrideParams.vendorID !== undefined ? overrideParams.vendorID : filterVendor;
        const brand = overrideParams && overrideParams.brandID !== undefined ? overrideParams.brandID : filterBrand;
        const seg = overrideParams && overrideParams.segment !== undefined ? overrideParams.segment : filterSegment;
        const subSeg = overrideParams && overrideParams.subSegment !== undefined ? overrideParams.subSegment : filterSubSegment;

        if (start) params.append("startDate", start);
        if (end) params.append("endDate", end);
        if (vendor) params.append("vendorID", vendor);
        if (brand) params.append("brandID", brand);
        if (seg) params.append("segment", seg);
        if (subSeg) params.append("subSegment", subSeg);

        fetch(`${API_URL}/companies/dashboard/data/${companyID}?${params.toString()}`)
            .then(res => res.json())
            .then(data => {
                setDashboardData(data);
            })
            .catch(err => console.error("Error fetching dashboard data:", err));
    };



    const exportPaymentModeDateSalesToXLSX = async () => {
        const XLSX = await import('xlsx');
        // Prepare headings
        const headings = ['Date', ...paymentModeLabels, 'Total'];
        // Prepare rows
        const rows = paymentModeDateLabels.map((date, idx) => {
            const values = paymentModeLabels.map(mode => {
                const ds = paymentModeDateSales.find(ds => ds.label === mode);
                return ds ? ds.data[idx] : 0;
            });
            const total = values.reduce((a, b) => a + b, 0);
            return [date, ...values, total];
        });
        // Totals for each payment mode
        const modeTotals = paymentModeLabels.map(mode => {
            const ds = paymentModeDateSales.find(ds => ds.label === mode);
            return ds ? ds.data.reduce((a, b) => a + b, 0) : 0;
        });
        const grandTotal = modeTotals.reduce((a, b) => a + b, 0);
        // Add total row
        const totalRow = ['Total', ...modeTotals, grandTotal];
        // Final data
        const data = [headings, ...rows, totalRow];
        // Create worksheet and workbook
        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'PaymentModeSales');
        // Download
        XLSX.writeFile(wb, 'PaymentModeWiseSales.xlsx');
    };

    return (
        <>
            {getModulePermissions({ module: 'Dashboard' }) ?
                (<div className="row align-items-stretch">
                    <div className="col-xxl-12">
                        <div className="row">
                            <div className='col-md-12'>
                                {renderDashboardFilters()}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-3 col-sm-6 col-12 d-flex">
                                <div className="card bg-primary sale-widget flex-fill">
                                    <div className="card-body d-flex align-items-center">
                                        <span className="sale-icon bg-white text-primary">
                                            <i className="ti ti-file-text fs-24" />
                                        </span>
                                        <div className="ms-2">
                                            <p className="text-white mb-1">Total Sales</p>
                                            <div className="d-inline-flex align-items-center flex-wrap gap-2">
                                                <h4 className="text-white">₹ {dashboardData ? formatAmount(dashboardData?.totalSalesAmount) : '...'}</h4>
                                                <span className="badge badge-soft-primary">{dashboardData ? Number(dashboardData.totalSalesBills).toLocaleString("en-IN") : '...'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-sm-6 col-12 d-flex">
                                <div className="card bg-teal sale-widget flex-fill">
                                    <div className="card-body d-flex align-items-center">
                                        <span className="sale-icon bg-white text-teal">
                                            <i className="ti ti-gift fs-24" />
                                        </span>
                                        <div className="ms-2">
                                            <p className="text-white mb-1">Total Purchases</p>
                                            <div className="d-inline-flex align-items-center flex-wrap gap-2">
                                                <h4 className="text-white">₹ {dashboardData ? formatAmount(dashboardData.totalPurchasesAmount) : '...'}</h4>
                                                <span className="badge badge-soft-success">{dashboardData ? Number(dashboardData.totalPurchases).toLocaleString("en-IN") : '...'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-sm-6 col-12 d-flex">
                                <div className="card bg-secondary sale-widget flex-fill">
                                    <div className="card-body d-flex align-items-center">
                                        <span className="sale-icon bg-white text-secondary">
                                            <i className="ti ti-repeat fs-24" />
                                        </span>
                                        <div className="ms-2">
                                            <p className="text-white mb-1">Exchange Bills </p>
                                            <div className="d-inline-flex align-items-center flex-wrap gap-2">
                                                <h4 className="text-white">₹ {dashboardData ? formatAmount(dashboardData.totalExchangeAmount) : '...'}</h4>
                                                <span className="badge badge-soft-danger">{dashboardData ? Number(dashboardData.totalExchangeBills).toLocaleString("en-IN") : '...'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-sm-6 col-12 d-flex">
                                <div className="card bg-info sale-widget flex-fill">
                                    <div className="card-body d-flex align-items-center">
                                        <span className="sale-icon bg-white text-info">
                                            <i className="ti ti-users fs-24" />
                                        </span>
                                        <div className="ms-2">
                                            <p className="text-white mb-1">Total Customers</p>
                                            <div className="d-inline-flex align-items-center flex-wrap gap-2">
                                                <h4 className="text-white">{dashboardData ? Number(dashboardData.totalCustomers).toLocaleString("en-IN") : '...'} &nbsp;</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='row'>


                            <div className="col-xxl-7 col-md-7">
                                <div className="card custom-card w-100" style={{ minHeight: 420 }}>
                                    <div className="card-header justify-content-between d-flex">
                                        <div className="card-title text-primary">Sales Chart</div>
                                        <div className='d-flex justify-content-end align-item-center gap-2'>
                                            {filter === "custom" && (
                                                <span className='d-flex justify-content-end align-item-center gap-2'>
                                                    <div className="position-relative">
                                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                            Start Date
                                                        </span>

                                                        <input
                                                            type="date"
                                                            value={customStart}
                                                            onChange={e => setCustomStart(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ display: "inline-block", width: 120, marginRight: 4 }}
                                                        />
                                                    </div>
                                                    <div className="position-relative">
                                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                            End Date
                                                        </span>

                                                        <input
                                                            type="date"
                                                            value={customEnd}
                                                            onChange={e => setCustomEnd(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ display: "inline-block", width: 120 }}
                                                        />
                                                    </div>
                                                </span>
                                            )}
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Filter
                                                </span>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={filter}
                                                    onChange={e => setFilter(e.target.value)}
                                                    style={{ minWidth: 150, marginRight: 8 }}
                                                >
                                                    {FILTERS.map(f => (
                                                        <option key={f.value} value={f.value}>{f.label}</option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div style={{ width: "100%", minHeight: 100 }}>
                                            <Bar data={chartData} options={chartOptions} height={100} plugins={[ChartDataLabels]} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xxl-5 col-md-5">
                                <div className="card custom-card" style={{ minHeight: 420 }}>
                                    <div className="card-header justify-content-between d-flex align-item-center gap-2">
                                        <div className="card-title text-primary">Sales by Payment Mode</div>
                                        <div className='d-flex justify-content-between align-item-center gap-2'>
                                            {filter_payment === "custom" && (
                                                <span className='d-flex justify-content-between align-item-center gap-2'>
                                                    <div className="position-relative">
                                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                            Start Date
                                                        </span>
                                                        <input
                                                            type="date"
                                                            value={customStartPayment}
                                                            onChange={e => setCustomStartPayment(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ display: "inline-block", width: 120, marginRight: 4 }}
                                                        />
                                                    </div>
                                                    <div className="position-relative">
                                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                            End Date
                                                        </span>
                                                        <input
                                                            type="date"
                                                            value={customEndPayment}
                                                            onChange={e => setCustomEndPayment(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ display: "inline-block", width: 120 }}
                                                        />
                                                    </div>
                                                </span>
                                            )}
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Filter
                                                </span>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={filter_payment}
                                                    onChange={e => setFilter_payment(e.target.value)}
                                                    style={{ minWidth: 150, marginRight: 8 }}
                                                >
                                                    {FILTERCHANGED.map(f => f.value != 'quarter' && (
                                                        <option key={f.value} value={f.value}>{f.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div style={{ width: "100%", minHeight: 185 }}>
                                            <Bar data={paymentModeChartData} options={paymentModeChartOptions} height={185} plugins={[ChartDataLabels]} />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="col-xxl-12">
                                <div className="card custom-card">
                                    <div className="card-header justify-content-between d-flex gap-2">
                                        <div className="card-title text-primary">Payment Mode Wise Sales (Date Wise)</div>
                                        <div className='d-flex justify-content-between align-items-center gap-2'>

                                            {filter_payment_date === "custom" && (
                                                <span className='d-flex justify-content-between align-items-center gap-2'>
                                                    <div className="position-relative">
                                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                            Start Date
                                                        </span>
                                                        <input
                                                            type="date"
                                                            value={customStartPaymentDate}
                                                            onChange={e => setCustomStartPaymentDate(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ display: "inline-block", width: 120, marginRight: 4 }}
                                                        />
                                                    </div>
                                                    <div className="position-relative">
                                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                            End Date
                                                        </span>
                                                        <input
                                                            type="date"
                                                            value={customEndPaymentDate}
                                                            onChange={e => setCustomEndPaymentDate(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ display: "inline-block", width: 120 }}
                                                        />
                                                    </div>
                                                </span>
                                            )}
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Filter
                                                </span>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={filter_payment_date}
                                                    onChange={e => setFilter_payment_date(e.target.value)}
                                                    style={{ marginRight: 8 }}
                                                >
                                                    {FILTERCHANGED.map(f => f.value != 'quarter' && (
                                                        <option key={f.value} value={f.value}>{f.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <button className="btn btn-success btn-sm ms-2" onClick={exportPaymentModeDateSalesToXLSX} style={{
                                                textWrap: "nowrap"
                                            }}>
                                                Export to Excel
                                            </button>

                                        </div>
                                    </div>
                                    <div className="card-body">
                                        {/* {renderPaymentModeSelector()} */}
                                        <div style={{ width: "100%", minHeight: 220 }}>
                                            <Bar data={paymentModeDateChartData} options={paymentModeDateChartOptions} height={220} plugins={[ChartDataLabels]} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>) :
                (
                    <div>Welcome to Absp Dashboard</div>
                )
            }
        </>
    );
};

export default CompanyDashboard;
